export default __webpack_public_path__ + "static/media/Conscript's Legguards of the Warring States.c052dd2d.jpg";